import * as categories from './list'

export const allCategories = Object.values(categories).sort(
    (previous, current) => previous.name.localeCompare(current.name),
)
